module.exports = (__webpack_require__("nK2o"))(38);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react-dom/lib/ReactReconciler.js from dll-reference drifthq_be9ca2588e6a06a8d4a8
// module id = xWyi
// module chunks = 89